import PropTypes from 'prop-types'

const CreateUserHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

CreateUserHeader.defaultProps = {
    title: 'Manage Bus Driver Account',
}

CreateUserHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default CreateUserHeader
